import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const UrlValidator =
  (): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    try {
      const url = new URL(control.value);
      const allowedProtocols = ['http:', 'https:'];
      if (!allowedProtocols.includes(url.protocol)) {
        return {
          invalidUrl: true,
          message: 'URL must use http or https protocol',
          isCustom: true
        };
      }
      return null;
    } catch {
      return {
        invalidUrl: true,
        message: 'Please enter a valid URL (e.g., https://example.com)',
        isCustom: true
      };
    }
  };
